// removed by extract-text-webpack-plugin
module.exports = {"Card":"_3u-IXkSOdBXKobjEAaEzpI","Title":"_1C9dKNq2HSxMIBmwc3huGj","Body":"_1CLrTZZb0pfIK-iqi9TMFJ"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/EmptyCard/styles.module.css
// module id = 649
// module chunks = 0